<template>
  <div style="position: relative; height: 0px" :class="show ? 'd-none d-sm-block' : 'd-none'">
  <div style="position: absolute; display:inline; top:50px; z-index: 1020; max-width: calc(100vw - 20px);
    transform: translate(calc(50vw - 50%), 0px); padding-top:3px;"
       class="breadcrumb m-0">
        <div style="display: inline-block; padding-top:2px;  overflow: hidden; ">
            <span style="padding-left: 3px; padding-right: 3px; cursor: pointer"
                  @click="homeClick" @mouseover="onMouseOver(null)" @mouseout="onMouseOut(null)">
              <font-awesome-icon icon="home" transform=""></font-awesome-icon>
            </span>
        </div>

        <div style="display: inline-block;  text-overflow: ellipsis; overflow: hidden; '+
                           'white-space: nowrap; max-width: calc((100vw - 34px) / ' + elements + ' - 23px) "
             v-for="item in items" :key="item.id">
          <span v-if="item.isSeparator" style="padding-left: 3px; padding-right: 3px;">
            <font-awesome-icon icon="arrow-right" transform="shrink-4"></font-awesome-icon>
          </span>
          <span v-if="item.isMultiSeparator">
            ...
          </span>
          <span v-if="!item.special" @mouseover="onMouseOver(item)" @mouseout="onMouseOut(item)"
                :style="item.__style"
                @click="clickItem(item)"
          >
            {{ item.getTitle() }}
          </span>
        </div>

  </div>
  </div>

</template>


<script>

import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

import ActivityModel from "@/activity/ActivityModel";
import Activity from "@/activity/Activity";
import Log  from "@/utils/Log";
import {Stack} from "buckets-js";

export default {
  name: "ActivityStackNavigator",

  components: {},

  mounted() {},

  created() {
    this.$onEvent(Events.onActivitiesStackChange, items =>
      this.refreshStack(items)
    );

    this.$onEvent(Events.workspaceHide, items => {
        this.show = false;        
    });

    this.$onEvent(Events.workspaceShow, items => {
        this.refreshStack(items);
        this.show = true;       

    });

  },

  methods: {

    onMouseOver(item){

      for(let i=0; i < this.items.length; i++){
        if((item?.__ord ?? -1) >= this.items[i].__ord){
          continue;
        }

        if(!this.items[i].special && this.items[i].closableInChain) {
          this.items[i].__style = "text-decoration:line-through; color:red";
        }
        if(i === this.items.length - 1){
          this.items[i].__style += "; font-weight:bold; padding-right:3px ";
        }
      }
    },

    clickItem(item){
      for(let i=0; i < this.items.length; i++) {
        if (item.__ord >= this.items[i].__ord) {
          continue;
        }

        if(!this.items[i].special) {
          this.items[i].closeChain(false, true);
          return;
        }
      }
    },
    homeClick(){
      for(let i=0; i < this.items.length; i++) {
        if(!this.items[i].special) {
          this.items[i].closeChain(false, true);
          return;
        }
      }
    },

    onMouseOut(item){
     this.resetStyles();
    },

    resetStyles(){
      for(let i=0; i< this.items.length; i++){
        let item = this.items[i];
        this.items[i].__style = (i !== this.items.length-1 ? 'cursor:pointer' : 'cursor:default');
        if(i === this.items.length - 1){
          this.items[i].__style += "; font-weight:bold; padding-right:3px ";
        }
      }
    },

    /**
     * @param {Stack} stack
     */
    refreshStack(stack) {
      this.stack = stack;
      let pathElements = stack.toArray();
      let navigableItems = [];

      let clickable = true;
      this.titleItem = null;

      for(let i=0; i< pathElements.length-1; i++){
        let element = pathElements[i];
        element.closableInChain = clickable;
        // if(i == 0){
        //    element.closableInChain = false;
        // }
        if(!element.activity.isClosable()){
          clickable = false;
        }

        let showMode = element.activity.showOnNavigator();        
        if( showMode == Activity.ON_PATH){
          navigableItems.push(element)
        } else if( showMode == Activity.AS_TITLE){
          if(this.titleItem == null){
            this.titleItem = element;
            Log.trace("Navbar title taken from: " + element.componentName);
            break;
          }
        } else  if(showMode != Activity.NONE){

        } else {
          Log.debug("Unknown showOnNavigator() response '" + showMode + "' in Activity:" + element.componentName);
        }
      }

      if(this.titleItem != null){
        this.titleClickable = this.titleItem.closableInChain;
        this.title = this.titleItem.activity.getTitle();
        this.titleIcon = this.titleItem.activity.getTitleIcon();
      }
      else {
        this.titleClickable = false;
        this.title = this.defaultTitle ? this.defaultTitle : "";
        this.titleIcon = this.defaultTitleIcon ? this.defaultTitleIcon : "";

      }

      navigableItems = navigableItems.reverse();
      pathElements = pathElements.reverse();


      if(pathElements.length > 0){
        /** @type {ActivityModel} */
        let last = pathElements[pathElements.length-1];
        if(last.activity.isClosable()){
          this.showButton = true;
          if(pathElements.length > 1){
            this.btnLabel = "Back to " +   pathElements[pathElements.length-2].activity.getTitle();
           }
           else {
            this.showButton = true;
            this.btnLabel = "Close " +   pathElements[pathElements.length-1].activity.getTitle();
           }

        } else {
          this.showButton = false;
        }
      } else {
          this.showButton = false;
      }

      let newItems = [];
      const limit = 6;
      if (navigableItems.length > limit){
        let shortenItems = [];
        shortenItems[0] = navigableItems[0];
        shortenItems[1] = {special:true, isMultiSeparator : true, id:'multi-sep'};
        for(let i=limit-1; i>0; i--){
          shortenItems.push(navigableItems[navigableItems.length - i]);
        }
        newItems= shortenItems;
      } else {
        newItems = navigableItems;
      }

      let mixedItems = [];
      for(let i=0; i< newItems.length; i++){
        mixedItems.push({special:true, isSeparator:true, id:`sep-${i}`});
        newItems[i].__ord = i;
        newItems[i].__style = "";
        mixedItems.push(newItems[i]);

      }
      this.elements = newItems.length || 1;
      this.items = mixedItems;
      this.resetStyles();
    },

    titleItemCloseChain(){
      if(this.titleItem != null){
        this.titleItem.closeChain();
      }
    },
    closeClick() {
      EventBus.$emit(Events.requestTopActivityClose);
    },


  },

  props: ["defaultTitle", "defaultTitleIcon"],
  data: function() {
    return {
      elements: 1,
      btnLabel: "",
      title: "",
      titleItem: null,
      titleIcon:"",
      titleClickable: false,
      on:false,
      showButton: false,
      show: false,
      stack: Stack(),
      items: []
    };
  }
};
</script>